import genericStore from "../generic_store";
import axios from "axios";
import { config } from "@/config/constants.js";
import jsonToFormData from "@ajoelp/json-to-formdata";
const api_path = config.api_url.replace("/admin/", "/");

export default {
  namespaced: genericStore.namespaced,
  state: {
    endpoints: {
      convert_to_pdf: api_path + "html_to_pdf"
    },
    status: null
  },
  mutations: {
    request(state) {
      state.status = "request";
    },
    success(state) {
      state.status = "success";
    },
    error(state) {
      state.status = "error";
    }
  },
  actions: {
    convertHtmlToPdf({ commit, state }, data) {
      return new Promise((resolve, reject) => {
        commit("request");
        axios
          .post(state.endpoints.convert_to_pdf, data,{headers:{'Content-type':'text/html'}})
          .then(response => {
            commit("success");
            resolve(response.data);
          })
          .catch(err => {
            commit("error");
            reject(err);
          });
      });
    }
  }
};
